import React from "react";
import { LoadingButton } from "@mui/lab";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import useFilePicker from "../../hooks/useFilePicker";

const UploadButton = ({ children, onSelect, onError, loading }) => {
  const { openFilePicker, filesContent } = useFilePicker(onSelect, onError, [
    ".jpg",
    ".png",
    ".jpeg",
  ]);

  if (!children) return;

  return (
    <LoadingButton
      variant="contained"
      startIcon={<CloudUploadIcon />}
      onClick={openFilePicker}
      loading={loading}
    >
      {children}
    </LoadingButton>
  );
};

export default UploadButton;
